import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-material.css";
import { useCallback, forwardRef } from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { lighten } from "@mui/material";

import Box from "@mui/material/Box";

ModuleRegistry.registerModules([AllCommunityModule]);

const ERPGrid = forwardRef<AgGridReact, React.PropsWithChildren<any>>(
  (
    { gridHeight, gridWidth, exportToExcel, heading, processBtn, ...gridProps },
    ref
  ) => {
    const onBtnExport = useCallback(() => {
      if (ref && "current" in ref && ref.current) {
        ref.current.api.exportDataAsCsv();
      }
    }, []);

    return (
      <Box
        className="ag-theme-material"
        sx={{
          width: gridWidth || "100%",
          height: gridHeight || "80vh",
          "& .ag-header-row": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
          "& .ag-row-odd": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
          "& .ag-row-hover": {
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "0.7rem",
            
          },
          "& .ag-cell": { paddingY: "4px" },
          "& .ag-row-focus": {
            backgroundColor: (theme) =>
              lighten(theme.palette.primary.light, 0.8),
            fontWeight: "bold",
          },
        }}
      >
        <Box
          display={"flex"}
          justifyContent={"flex-start"}
          alignItems={"center"}
        >
          {processBtn && (
            <Button
              onClick={processBtn.onClick}
              color={processBtn.color}
              sx={{ mb: 1, mr: 1, width: "160px" }}
              variant="outlined"
            >
              {processBtn.label}
            </Button>
          )}
          {exportToExcel && (
            <Button
              variant="outlined"
              onClick={onBtnExport}
              sx={{ mb: 1, width: "160px" }}
            >
              Export to Excel
            </Button>
          )}

          {heading && (
            <Typography
              sx={{ flex: 1, fontWeight: "bold" }}
              textAlign={"center"}
            >
              {heading}
            </Typography>
          )}
        </Box>
        <AgGridReact ref={ref} {...gridProps}   />
      </Box>
    );
  }
);

export default ERPGrid;
